import React, { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";
import toast from "react-hot-toast";

import { getProposalWorkspaceSettings, updateProposalWorkspaceSettings } from "../api/prospectingReportsApi";

const Toggle = ({ on, onChange }) => (
  <button type="button" onClick={() => onChange(!on)}
    className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${on ? "bg-[#2f9e6b]" : "bg-gray-300"}`}>
    <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${on ? "translate-x-5" : "translate-x-0.5"}`} />
  </button>
);

/** Proply gear → "Proposal settings" — defaults applied to each new proposal. */
const ProposalSettingsModal = ({ onClose }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    getProposalWorkspaceSettings().then(({ data }) => setSettings(data)).catch(() => toast.error("Could not load settings."));
  }, []);

  const set = async (field, value) => {
    const next = { ...settings, [field]: value };
    setSettings(next);
    try {
      await updateProposalWorkspaceSettings({ [field]: value });
    } catch (e) {
      toast.error("Could not save.");
      setSettings((s) => ({ ...s, [field]: !value }));
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-md">
        <div className="flex items-start justify-between p-5 border-b border-gray-100">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Proposal settings</h2>
            <p className="text-sm text-gray-500 mt-1">Adjust the default settings applied to each new proposal.</p>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-5 h-5" /></button>
        </div>
        {!settings ? (
          <div className="flex justify-center py-12 text-gray-400"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : (
          <div className="p-5">
            <h3 className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Team sharing defaults</h3>
            <div className="flex items-center justify-between py-2">
              <span className="text-sm text-gray-700">Share new proposals with entire team</span>
              <Toggle on={!!settings.share_new_with_team} onChange={(v) => set("share_new_with_team", v)} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProposalSettingsModal;
